<app-create-quick-payment-terms-lookup (PaymentTermsId)="close($event)"></app-create-quick-payment-terms-lookup>

